export default {
  edi: {
    title: "EDI",
    profile: "Hồ sơ",
    profile_name: "Tên hồ sơ",
    im: "Nhập dữ liệu",
    ex: "Xuất dữ liệu",
    table: "Tên bảng",
    type: "Kiểu EDI",
    column: 'Cột',
    submit: 'Bắt đầu nhập',
    close: 'Đóng',
    columnData: 'Dữ liệu cho cột',
    chooseColumn: 'Chọn một cột',
    selected: 'Đã chọn',
    select: 'Chọn',
    selectColumn: 'Chọn một cột',
    primary_key: 'Primary Keys',
    column_mapping: 'Columns mapping',
    update_conditions: 'Update Conditions',
    select_profile: 'Chọn Profile',
    select_file: 'Tải lên và chọn cột phù hợp',
    start_upload: 'Bắt đầu nhập dữ liệu',
    result: {
      success: 'Kết quả nhập dữ liệu: Thêm mới {inserted} mục, Cập nhật: {updated} mục!',
      failure: 'Lỗi nhập dữ liệu!'
    },
    file: {
      select: 'Vui lòng chọn file',
      tryAgain: 'Chọn file khác',
      withHeaders: 'This file includes headers',
      withoutHeaders: 'This file does not include headers',
    },
    error: {
      title: 'Error',
      columnNumber: 'You do not have enough columns. <br><b>Required columns are</b>: ',
      missingColumns: 'Missing required columns:',
      selectColumn: 'You need to select all columns',
      fileNumber: 'You need to select a file',
      fileSelection: 'No file has been selected',
      invalidFile: 'This file is invalid. Try to use a CSV or Xlsx file',
      noWorksheet: 'Must have at least one worksheet',
      emptyWorksheet: 'File trống',
    },
  }
};
